import React, { useContext } from "react";
import Carousel from "./Carousel";
import LoadingCircle from "./LoadingCircle";
import { InfoContext } from "./InfoContext";

const TeamList: React.FC = () => {
  const { teams, isLoading } = useContext(InfoContext);

  return (
    <div className="flex flex-col justify-center items-center overflow-hidden w-full">
      <h2 className="mt-10 text-left text-2xl font-semibold text-white">
        Clubs
      </h2>
      {isLoading ? <LoadingCircle /> : <Carousel items={teams} />}
    </div>
  );
};

export default TeamList;
